export default class Utils {
  static isEmpty(str) {
    return !str || str.length === 0;
  }
}
